import Modal from "app/components/Modal/Modal";
import { Toggle } from "app/components/Toggle/Toggle";
import { useState } from "react";
import { FormattedMessage, useIntl } from "react-intl";
import { register2fa, remove2fa } from "./TwoFactorApi";
import "./TwoFactorAuth.scss";
import TwoFactorSetup from "./TwoFactorSetUp";

// Shows a label and a toggle
// When toggle activated, shows a modal with a qr code and a secret code
// The modal configures 2fa for the account
// When toggle deactivated, removes the 2fa

export default function TwoFactorAuth({
  twoFactorAuthenticationEnabled,
}: {
  twoFactorAuthenticationEnabled: boolean;
}) {
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [qrCodeUrl, setQrCodeUrl] = useState("");
  const [secretCode, setSecretCode] = useState("");
  const [error, setError] = useState("");
  const [successMessage, setSuccessMessage] = useState("");
  const [toggleValue, setToggleValue] = useState(
    twoFactorAuthenticationEnabled
  );
  const intl = useIntl();

  const onVerify = () => {
    setIsModalVisible(false);
    setSuccessMessage(
      intl.formatMessage({
        id: "2fa-setup-success",
        defaultMessage: "2FA setup successfully",
      })
    );
  };

  const handleRemove2fa = async () => {
    setError("");
    const response = await remove2fa();
    if (response.success) {
      setSuccessMessage(
        intl.formatMessage({
          id: "2fa-removed-successfully",
          defaultMessage: "2FA removed successfully",
        })
      );
    } else {
      console.error(response.error);
      setError(response.error);
    }
  };

  const handleRegister2fa = async () => {
    setError("");
    const response = await register2fa();
    if (response.success) {
      // Show the modal with qr code etc
      setIsModalVisible(true);
      setQrCodeUrl(response.data.data.qrCodeUrl);
      setSecretCode(response.data.data.secretCode);
      setSuccessMessage("");
      setError("");
    } else {
      console.log("!!response.error", response.error);
      setError(response.error);
      // if error happens, set the toggle back to initial value
      setToggleValue(twoFactorAuthenticationEnabled);
    }
  };

  const handleClick = (value: boolean) => {
    setToggleValue(value);
    if (value) {
      handleRegister2fa();
    } else {
      handleRemove2fa();
    }
  };

  return (
    <div className="two-factor-auth__container">
      <div className="two-factor-auth__container__content">
        <h5>
          <FormattedMessage id="two-factor-auth" />
        </h5>
        <Toggle
          isEnabled={toggleValue}
          onToggle={value => handleClick(value)}
        />
      </div>
      <div className="two-factor-auth__container__messages">
        {error && <p className="two-factor-auth__error-message">{error}</p>}
        {successMessage && (
          <p className="two-factor-auth__success-message">{successMessage}</p>
        )}
      </div>

      <Modal
        modalOpen={isModalVisible}
        closeModal={() => {
          setIsModalVisible(false);
          setToggleValue(false);
        }}
        contentLabel="Password Reset"
        cancelButton
        className="auth-screen__username-modal"
      >
        <TwoFactorSetup
          onVerify={() => {
            onVerify();
          }}
          qrCode={qrCodeUrl}
          secretCode={secretCode}
        />
      </Modal>
    </div>
  );
}
